import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchers } from "../fetchers";

export const PROFILES_KEY = "profiles";

const useFetchProfile = (userId: string | null) => {
  return useQuery({
    queryKey: [PROFILES_KEY, userId],
    queryFn: () => (userId ? fetchers.profiles.fetchProfile(userId) : undefined),
    enabled: !!userId,
  });
};

const useCreateProfile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [PROFILES_KEY],
    mutationFn: fetchers.profiles.createProfile,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [PROFILES_KEY] });
      queryClient.setQueryData([PROFILES_KEY, data.id], data);
    },
  });
};

const useUpdateProfile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [PROFILES_KEY],
    mutationFn: ({
      userId,
      profile,
    }: {
      userId: string;
      profile: Parameters<typeof fetchers.profiles.updateProfile>[1];
    }) => fetchers.profiles.updateProfile(userId, profile),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [PROFILES_KEY] });
      queryClient.setQueryData([PROFILES_KEY, data.id], data);
    },
  });
};

const useDeleteProfile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [PROFILES_KEY],
    mutationFn: fetchers.profiles.deleteProfile,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PROFILES_KEY] });
    },
  });
};

export const profilesHooks = {
  useFetchProfile,
  useCreateProfile,
  useUpdateProfile,
  useDeleteProfile,
};
